import { action } from 'easy-peasy'
import { User } from '../../store/interfaces/user'
import { IUserInfo } from '../../types/IUserInfo'

/**
 * State default values and implementation of actions
 */
export const user: User = {
  //    ______       __
  //   / __/ /____ _/ /____
  //  _\ \/ __/ _ `/ __/ -_)
  // /___/\__/\_,_/\__/\__/

  authenticated: false,
  company: '',
  email: '',
  firstName: '',
  fullName: '',
  language: '',
  lastName: '',
  info: {} as IUserInfo,

  //    ___      __  _
  //   / _ |____/ /_(_)__  ___  ___
  //  / __ / __/ __/ / _ \/ _ \(_-<
  // /_/ |_\__/\__/_/\___/_//_/___/

  resetUser: action((state) => {
    state.authenticated = false
    state.company = ''
    state.email = ''
    state.firstName = ''
    state.fullName = ''
    state.language = ''
    state.lastName = ''
    state.info = {} as IUserInfo
  }),

  setAuthenticated: action((state, payload) => {
    state.authenticated = payload
  }),

  setCompany: action((state, payload) => {
    state.company = payload
  }),

  setEmail: action((state, payload) => {
    state.email = payload
  }),

  setFirstName: action((state, payload) => {
    state.firstName = payload
  }),

  setFullName: action((state, payload) => {
    state.fullName = payload
  }),

  setLanguage: action((state, payload) => {
    state.language = payload
  }),

  setLastName: action((state, payload) => {
    state.lastName = payload
  }),

  setInfo: action((state, payload) => {
    state.info = payload
  }),
}
